import {Text} from '@/components/ui/text/Text'
import styled from 'styled-components'

export const StyledContactNotes = styled(Text)`
    white-space: nowrap;
`
